import BonusesDetail from './BonusesDetail';
import { BonusesPaymentForm } from './BonusesPaymentForm';
import { useBonusesPayment } from './useBonusesPayment';

export interface IBonusesPaymentProps {
    showBonusesPayment: boolean,
    isOnlyBonusesPay: boolean,
    availableBonuses: number,
    value: string | number,
    maxLength: string,
    isChecked: boolean,
    isDisabled: boolean,
    isValid: boolean,
    onToggle: () => void,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void,
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void,
}

/**
 * Форма для оплаты бонусами (контейнер)
 */
export const BonusesPayment = (): JSX.Element | null => {
    const bonusesPaymentProps = useBonusesPayment();

    if (!bonusesPaymentProps.showBonusesPayment) {
        return null;
    }

    return (
        <>
            <BonusesPaymentForm {...bonusesPaymentProps}/>
            <BonusesDetail/>
        </>
    );
};
